import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { GoogleLogin } from "@react-oauth/google";
import { useGoogleAuthMutation } from "../store/apis/authApis";
import { SignInContainer } from "./components/SignInContainer";
import { Card } from "./components/Card";
import { openErrorToast } from "../store/slices/toast/toastSlice";
import { useDispatch } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";

export default function SignIn() {
  const dispatch = useDispatch();
  const [googleAuthMutate] = useGoogleAuthMutation();
  const handleGoogleCredentials = async (response) => {
    try {
      const model = {
        credential: response.credential,
      };
      const loginResponse = await googleAuthMutate(model);
      if (loginResponse) {
        if (!loginResponse.data.isSuccess) {
          dispatch(openErrorToast(loginResponse.data.message));
        } else {
          localStorage.setItem("access-token", loginResponse.data.data.token);
          window.location.href = "/";
        }
      }
    } catch (error) {
      console.error("Google login error:", error);
    }
  };

  return (
    <>
      <CssBaseline enableColorScheme />
      <SignInContainer direction="column" justifyContent="space-between">
        <Card variant="solid">
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}
          >
            Giriş
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <GoogleLogin
              onSuccess={handleGoogleCredentials}
              onError={() => {
                console.log("Login Failed");
              }}
            />
          </Box>
        </Card>
      </SignInContainer>
    </>
  );
}
